module.exports = __webpack_public_path__ + "media/assets/images/fake-simulation-en-b64cdf70fbc615d16b2f5868a164d019.png";